module.exports = __webpack_public_path__ + "static/img/07.8c8310d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/07.jpg
// module id = uK5D
// module chunks = 0